// src/utils/roleHelpers.js

// Obtiene el rol del usuario desde localStorage
export const getUserRole = () => {
    const user = localStorage.getItem('user');
    if (!user) return null;

    try {
        const parsedUser = JSON.parse(user);
        return parsedUser.role || null;
    } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
        return null;
    }
};

// Comprueba si el usuario tiene un rol específico
export const hasRole = (requiredRole) => {
    const role = getUserRole();
    return role === requiredRole;
};

// Comprueba si el usuario tiene uno de varios roles
export const hasAnyRole = (roles) => {
    const role = getUserRole();
    return roles.includes(role);
};

// has admin
export const hasAdminRole = () => {
    return hasRole('admin');
};